import { FunctionComponent, useState } from 'react'
import { Daycare } from '@/types/Daycare'
import { useMutation } from '@apollo/client'
import { SET_MAIL_SIGNATURE } from '@/modules/API/daycare/daycareHandler'
import styles from '../customisation.module.scss'
import Title from '@/components/_custom/Title/title'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useTranslation } from 'react-i18next'
import { ResetTv } from '@mui/icons-material'
import TextArea from '@/components/_custom/TextArea/textArea'
import { useAuth } from '@/modules/context/AuthContext'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import DialogActions from '@/components/_custom/DialogActions/DialogActions'

interface MailSignatureProps {
    daycare: Daycare
}

const MailSignature: FunctionComponent<MailSignatureProps> = ({ daycare }: MailSignatureProps) => {
    const { t } = useTranslation()

    const { user, fetchCurrentDaycare } = useAuth()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [newSignature, setNewSignature] = useState<string>(daycare.mailSignature)

    const [signature, setSignature] = useState<string>(daycare.mailSignature)

    const [setNewMailSignature] = useMutation(SET_MAIL_SIGNATURE, {
        variables: {
            daycareId: daycare.id,
            signature: signature
        },
        onCompleted: () => {
            setNewSignature(signature)

            fetchCurrentDaycare()

            showNotificationSuccess(t('signatureUpdated'))
        },
        onError: () => {
            showNotificationError(t('signatureUpdateError'))
        }
    })

    function handleReset(): void {
        setSignature(t('defaultSignature'))
        setNewMailSignature({
            variables: {
                daycareId: daycare.id,
                signature: t('defaultSignature')
            }
        })
    }

    return (
        <div className={styles.MailSignaturePlacement}>
            <div className={styles.Form}>
                <div className={styles.TitleAndButton}>
                    <Title text={t('mySignature')} className={styles.Title} />
                </div>
                <div className={styles.InputContainer}>
                    <TextArea
                        id={'mailSignature'}
                        value={signature}
                        disabled={!user?.currentDaycareRights.canWriteParamsDaycare}
                        onChange={setSignature}
                        maxCount={100}
                        minRows={2}
                        maxRows={3}
                        className={styles.TextArea}
                    />
                    {user?.currentDaycareRights.canWriteParamsDaycare && (
                        <DialogActions>
                            <ButtonTextIcon
                                type={'custom'}
                                onClick={handleReset}
                                customText={t('reset')}
                                customIcon={<ResetTv />}
                                className={styles.Button}
                                nowrap
                            />
                            <ButtonTextIcon
                                type={'update'}
                                onClick={() => setNewMailSignature()}
                                className={styles.Button}
                                disabled={newSignature === signature}
                                nowrap
                            />
                        </DialogActions>
                    )}
                </div>
            </div>
        </div>
    )
}

export default MailSignature
